module.exports = __webpack_public_path__ + "static/media/brew.9276d60b.png";